'use client'

import { type FC } from 'react'
import { useStats } from 'react-instantsearch'
import { FormattedMessage } from 'react-intl'

import { ProductSearchResultInfoIconButton } from './ProductSearchResultInfoIconButton'

export const ProductSearchResultInfo: FC = () => {
  const { nbHits } = useStats()

  return (
    <div
      className="text-s font-bold text-dark-primary-strong"
      data-qa-id="search-result-result-counter"
    >
      <FormattedMessage
        id="searchResults.label.totalResultsNumber"
        values={{ total: nbHits }}
      />
      <ProductSearchResultInfoIconButton />
    </div>
  )
}
